import { Component, Input } from '@angular/core';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'irembogov-inline-toast',
  templateUrl: './in-line-toast.component.html',
  styleUrls: ['./in-line-toast.component.scss'],
  imports: [NgbToast],
})
export class InlineToastComponent {
  @Input() message = '';
  @Input() delay = 3000;
  @Input() type: 'success' | 'error' | 'warning' | 'info' | undefined;
  @Input() show = false;
  @Input() autohide = true;

  hideToast() {
    this.show = false;
  }
}
